import React from "react";
import { Link } from "react-router-dom";
import { Eyebrow, Cta } from "../../components/site/kit";
import { Reveal } from "../../components/site/motion";
import { useCases } from "../../lib/casesApi";
import { useHomeCopy } from "../../lib/siteContent";
import { RichCopy } from "../../components/site/RichCopy";
import { BgDepth } from "./shared";

export const Work = () => {
  const cases = useCases();
  const c = useHomeCopy();
  const bySlug = (s) => cases.find((c) => c.slug === s);
  const lead = bySlug("data-into-growth") || cases[0];
  const supporting = [bySlug("efficiency-into-growth"), bySlug("opportunity-into-growth")].filter(Boolean);
  if (!lead) return null;
  return (
  <section data-testid="home-work" className="relative overflow-hidden border-b border-black/10 bg-[#F7F6F2]">
    <BgDepth />
    <div className="relative mx-auto max-w-[1360px] px-6 py-24 md:px-12 md:py-32 lg:px-16">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-xl">
          <Eyebrow>{c.workEyebrow}</Eyebrow>
          <h2 className="font-display mt-6 text-4xl leading-[0.95] tracking-tight text-black md:text-5xl lg:text-6xl">
            <RichCopy text={c.workHeading} />
          </h2>
          <p className="font-body mt-5 text-lg font-normal leading-relaxed text-black/70">
            {c.workIntro}
          </p>
        </div>
        <Cta to="/our-work" testId="home-work-cta">See all work</Cta>
      </div>

      <Reveal className="mt-14 grid gap-6 lg:grid-cols-12 lg:gap-8">
        {/* featured lead case */}
        <Link to={`/our-work/${lead.slug}`} data-testid="home-work-lead" className="group relative overflow-hidden bg-[#161A15] lg:col-span-7">
          <img src={lead.image} alt="" loading="lazy" decoding="async" className="aspect-[16/11] w-full object-cover opacity-80 grayscale-0 transition-all duration-500 group-hover:scale-[1.03] group-hover:opacity-100" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(22,26,21,0) 40%, rgba(22,26,21,0.88) 100%)" }} />
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-6 p-8 md:p-10">
            <div>
              <span className="font-body text-sm font-semibold uppercase tracking-[0.14em] text-[#5f8f10]">Featured / {lead.kicker}</span>
              <h3 className="font-display mt-3 max-w-xl text-3xl uppercase leading-[0.95] tracking-tight text-white md:text-4xl">{lead.headline}</h3>
              <p className="font-body mt-3 max-w-md text-base font-normal text-white/75">{lead.client}</p>
            </div>
            <span aria-hidden className="mb-2 hidden shrink-0 text-2xl text-[#5f8f10] transition-transform duration-300 group-hover:translate-x-1 md:block">→</span>
          </div>
        </Link>

        {/* supporting cases */}
        <div className="flex flex-col gap-6 lg:col-span-5">
          {supporting.map((w) => (
            <Link key={w.slug} to={`/our-work/${w.slug}`} data-testid={`home-work-${w.slug}`} className="group flex flex-1 items-stretch gap-5 border border-black/15 bg-white p-4 transition-colors duration-200 hover:border-[#5f8f10]">
              <div className="w-32 shrink-0 overflow-hidden md:w-40">
                <img src={w.image} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]" />
              </div>
              <div className="flex flex-1 flex-col justify-center py-2">
                <span className="font-body text-sm font-semibold uppercase tracking-[0.14em] text-[#5f8f10]">{w.kicker}</span>
                <h3 className="font-display mt-2 text-xl uppercase leading-[0.98] tracking-tight text-black transition-colors duration-200 group-hover:text-[#5f8f10] md:text-2xl">{w.headline}</h3>
                <span className="font-body mt-3 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.12em] text-[#5f8f10]">
                  View case <span aria-hidden className="transition-transform duration-200 group-hover:translate-x-1">→</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
  );
};
